import { Box, Typography } from '@mui/material'
import { footerLinksStyles } from 'src/view/layout/Footer'

function TermsOfUse() {
  return (
    <Box sx={footerLinksStyles.container}>
      <Typography variant="h3" sx={footerLinksStyles.heading}>
        Terms of Use
      </Typography>
      
      <Typography sx={footerLinksStyles.effectiveDate}>
        Effective date: March 2, 2026
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        Welcome to proxio.media (the "Site"). By accessing or using the Site, you agree to these Terms of Use ("Terms"). If you do not agree, do not use the Site.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        1) Who we are
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        The Site is owned and operated by Proxio, Ltd ("Proxio," "we," "us," "our"), a British Virgin Islands company.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        2) Permitted use
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        You may use the Site for personal, non-commercial purposes. You agree not to:
      </Typography>
      
      <ul>
        <li>Copy, scrape, republish, sell, or distribute Site content except as permitted by law or with our written permission</li>
        <li>Circumvent access controls, interfere with Site operations, or attempt unauthorized access</li>
        <li>Use the Site to transmit malware, spam, or unlawful content</li>
      </ul>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        3) Intellectual property
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        The Site's design, trademarks, and Proxio-produced materials are owned by Proxio or licensed to us and are protected by applicable intellectual property laws.
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        News reporting that originates from third parties (including news agencies) may be subject to the rights of those third parties.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        4) Third-party links
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        The Site may include links to third-party sites. Proxio is not responsible for the content, policies, or practices of third parties.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        5) Disclaimers
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        The Site is provided on an "as is" and "as available" basis. While Proxio strives for accuracy and timely updates, we do not warrant that content will be error-free, complete, or continuously available.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        6) Limitation of liability
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        To the maximum extent permitted by law, Proxio will not be liable for indirect, incidental, consequential, special, or punitive damages arising from your use of (or inability to use) the Site.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        7) Changes
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        We may update the Site and these Terms from time to time. Continued use of the Site after changes means you accept the updated Terms.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        8) Governing law
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        These Terms are governed by the laws of the British Virgin Islands, without regard to conflict-of-law rules.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        9) Contact
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        Questions about these Terms: contact@proxio.media
      </Typography>
    </Box>
  )
}

export default TermsOfUse
